import { useState, createContext } from 'react'

export const DrawPageStateContext = createContext({})

const DrawPageState = ({ children }) => {
    const [showHotEdit, setShowHotEdit] = useState(false)
    const [currentModule, setCurrentModule] = useState(null)
    return (
        <DrawPageStateContext.Provider
            value={{
                currentModule,
                setCurrentModule,
                showHotEdit,
                setShowHotEdit,
            }}
        >
            {children}
        </DrawPageStateContext.Provider>
    )
}

export default DrawPageState